import { Children, useMemo } from 'react';
import { Box, Grid, Stack } from '@mui/material';
import { getValidChild } from '@helpers';
import { Button } from '@elements/button';
import { StyledPopupContainer } from './popup.styles';
import { PopupContent } from './slots/popup-content';
import { PopupFooter } from './slots/popup-footer';
import { PopupTitle } from './slots/popup-title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * PopupSlot component.
 *
 * @author Mikhail Siutsou
 * @function Popup
 * @category components
 * @param {PopupProps} popup props.
 * @return {JSX.Element} popup component.
 */
var Popup = function Popup(_ref) {
  var children = _ref.children,
      handleClose = _ref.handleClose,
      acceptPopup = _ref.acceptPopup,
      rejectPopup = _ref.rejectPopup,
      popupId = _ref.popupId,
      popUp = _ref.popUp,
      fullScreen = _ref.fullScreen;
  var childrenArray = Children.toArray(children);
  var title = useMemo(function () {
    return childrenArray.find(getValidChild(PopupTitle));
  }, [childrenArray]);
  var content = useMemo(function () {
    return childrenArray.find(getValidChild(PopupContent));
  }, [childrenArray]);
  var footer = useMemo(function () {
    return childrenArray.find(getValidChild(PopupFooter));
  }, [childrenArray]);
  /**
   * Reject popup.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */

  var handleRejectPopup = function handleRejectPopup() {
    rejectPopup && rejectPopup();
  };
  /**
   * Accept popup.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */


  var handleAcceptPopup = function handleAcceptPopup() {
    acceptPopup && acceptPopup();
  };

  return /*#__PURE__*/_jsx(StyledPopupContainer, {
    $fullScreen: fullScreen,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: 4.5,
      flex: 1,
      children: [/*#__PURE__*/_jsxs(Box, {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        children: [title && /*#__PURE__*/_jsx(PopupTitle, {
          acceptPopup: acceptPopup,
          rejectPopup: rejectPopup,
          handleClose: handleClose,
          popupId: popupId,
          popUp: popUp,
          children: title.props.children
        }), content && /*#__PURE__*/_jsx(PopupContent, {
          acceptPopup: acceptPopup,
          rejectPopup: rejectPopup,
          handleClose: handleClose,
          popupId: popupId,
          popUp: popUp,
          children: content.props.children
        }), footer && /*#__PURE__*/_jsx(PopupFooter, {
          acceptPopup: acceptPopup,
          rejectPopup: rejectPopup,
          handleClose: handleClose,
          popupId: popupId,
          popUp: popUp,
          children: footer.props.children
        })]
      }), popUp && popUp.data && (popUp.data.acceptButton || popUp.data.rejectButton) && /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsxs(Grid, {
          container: true,
          spacing: 1,
          justifyContent: {
            md: 'center'
          },
          children: [popUp.data.rejectButton && /*#__PURE__*/_jsx(Grid, {
            item: true,
            xs: 12,
            md: "auto",
            children: /*#__PURE__*/_jsx(Button, {
              variant: "outlined",
              color: "secondary",
              size: "small",
              onClick: handleRejectPopup,
              fullWidth: true,
              children: popUp.data.rejectButton
            })
          }), popUp.data.acceptButton && /*#__PURE__*/_jsx(Grid, {
            item: true,
            xs: 12,
            md: "auto",
            children: /*#__PURE__*/_jsx(Button, {
              variant: "contained",
              size: "small",
              color: popUp.data.isDelete ? 'secondary' : 'inherit',
              onClick: handleAcceptPopup,
              fullWidth: true,
              children: popUp.data.acceptButton
            })
          })]
        })
      })]
    })
  });
};

Popup.Title = PopupTitle;
Popup.Content = PopupContent;
Popup.Footer = PopupFooter;
export { Popup };